/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AccountControllerDtoAccountDefaultInfoWithdrawalData model module.
 * @module model/AccountControllerDtoAccountDefaultInfoWithdrawalData
 * @version 1.0
 */
class AccountControllerDtoAccountDefaultInfoWithdrawalData {
    /**
     * Constructs a new <code>AccountControllerDtoAccountDefaultInfoWithdrawalData</code>.
     * @alias module:model/AccountControllerDtoAccountDefaultInfoWithdrawalData
     */
    constructor() { 
        
        AccountControllerDtoAccountDefaultInfoWithdrawalData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccountControllerDtoAccountDefaultInfoWithdrawalData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountControllerDtoAccountDefaultInfoWithdrawalData} obj Optional instance to populate.
     * @return {module:model/AccountControllerDtoAccountDefaultInfoWithdrawalData} The populated <code>AccountControllerDtoAccountDefaultInfoWithdrawalData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountControllerDtoAccountDefaultInfoWithdrawalData();

            if (data.hasOwnProperty('withdrawalNo')) {
                obj['withdrawalNo'] = ApiClient.convertToType(data['withdrawalNo'], 'Number');
            }
            if (data.hasOwnProperty('reason')) {
                obj['reason'] = ApiClient.convertToType(data['reason'], 'String');
            }
            if (data.hasOwnProperty('completionAt')) {
                obj['completionAt'] = ApiClient.convertToType(data['completionAt'], 'Date');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('managerNo')) {
                obj['managerNo'] = ApiClient.convertToType(data['managerNo'], 'Number');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountControllerDtoAccountDefaultInfoWithdrawalData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountControllerDtoAccountDefaultInfoWithdrawalData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['reason'] && !(typeof data['reason'] === 'string' || data['reason'] instanceof String)) {
            throw new Error("Expected the field `reason` to be a primitive type in the JSON string but got " + data['reason']);
        }

        return true;
    }


}



/**
 * @member {Number} withdrawalNo
 */
AccountControllerDtoAccountDefaultInfoWithdrawalData.prototype['withdrawalNo'] = undefined;

/**
 * @member {String} reason
 */
AccountControllerDtoAccountDefaultInfoWithdrawalData.prototype['reason'] = undefined;

/**
 * @member {Date} completionAt
 */
AccountControllerDtoAccountDefaultInfoWithdrawalData.prototype['completionAt'] = undefined;

/**
 * @member {Number} status
 */
AccountControllerDtoAccountDefaultInfoWithdrawalData.prototype['status'] = undefined;

/**
 * @member {Number} managerNo
 */
AccountControllerDtoAccountDefaultInfoWithdrawalData.prototype['managerNo'] = undefined;

/**
 * @member {Date} updatedAt
 */
AccountControllerDtoAccountDefaultInfoWithdrawalData.prototype['updatedAt'] = undefined;

/**
 * @member {Date} createdAt
 */
AccountControllerDtoAccountDefaultInfoWithdrawalData.prototype['createdAt'] = undefined;






export default AccountControllerDtoAccountDefaultInfoWithdrawalData;

